module.exports = __webpack_public_path__ + "media/images/icons/delete-2edee9616f5194ad80659a0fdfc264e0.gif";